<template>
  <div>
    <v-container grid-list-xl class="word-wrap mt-0">
      <v-layout row wrap justify-center mt-0 pb-5>
        <v-flex xs12 md8>
          <v-card
            class="defaultCardClass px-0"
            style="
              background-color: transparent !important;
              border: 0px solid red !important;
            "
            flat
          >
            <v-card-title
              class="text-center pt-6 pb-0 px-0 mx-0 justify-center align-center"
            >
              <v-text-field
                v-model="searchTextModel"
                :label="getLabel()"
                v-on:keyup.enter="searchText"
                outlined
                rounded
              >
                <template v-slot:append>
                  <v-btn
                    text
                    :disabled="searchTextModel.length < 3"
                    color="primary"
                    @click="searchText"
                    class="text-capitalize"
                    style="margin-top: -7px"
                  >
                    {{ $t("buttons.search") }}
                  </v-btn>
                </template>
              </v-text-field>
            </v-card-title>
          </v-card>

          <v-tabs
            v-model="tab"
            color="defaultColor"
            background-color="transparent"
            grow
          >
            <v-tabs-slider color="defaultColorLightTwo"></v-tabs-slider>
            <v-tab
              v-for="tabItem in tabItems"
              :key="tabItem.data"
              @click="changeTab()"
            >
              {{ tabItem.title }}
            </v-tab>
          </v-tabs>

          <hr style="position: absolute; width: 100%; left: 0px" />

          <v-tabs-items
            v-model="tab"
            style="
              background-color: transparent !important;
              overflow-y: scroll;
              height: calc(100vh - 270px);
            "
          >
            <v-tab-item v-for="tabItem in tabItems" :key="tabItem.data">
              <loading-progress :status="loadingList[tabItem.data]" />
              <v-list
                subheader
                :two-line="tab == 2 ? false : true"
                class="pa-5"
                style="background-color: transparent !important"
              >
                <div
                  v-for="(item, index) in data[tabItem.data]"
                  :key="item.Id.concat(index.toString())"
                >
                  <div v-if="tab == 0 && data[tabItem.data].length > 0">
                    <feed-item-card
                      class="test-diagno mb-5"
                      :itemData="item"
                      :index="index"
                      :hideMoreMenu="true"
                    />
                  </div>

                  <div v-if="tab == 1 && data[tabItem.data]">
                    <user-list-item
                      :item="item"
                      :avatar="item.Avatar"
                      :fullName="item.FullName"
                      :department="item.Department"
                      :userId="item.Id"
                      :company="item.Company"
                      :noBg="true"
                      :divider="true"
                    />
                  </div>

                  <div
                    v-if="tab == 2 && data[tabItem.data]"
                    @click="gotoPostWithTag(item)"
                    style="cursor: pointer"
                  >
                    <tag-list-item
                      v-if="tagResult"
                      :tagName="item.TagName"
                      :tagCount="item.Count"
                    />
                  </div>
                </div>

                <div
                  class="text-center"
                  v-if="
                    tab == 0 &&
                    data.searchPostsData.length > 0 &&
                    !moreButtonHidden
                  "
                >
                  <v-btn
                    text
                    color="primary"
                    @click="loadMore()"
                    :loading="loadingList.searchPostsData"
                    class="text-capitalize"
                  >
                    {{ $t("buttons.more") }}
                  </v-btn>
                </div>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import UserService from "@/services/UserService";
import FeedItemCard from "../../components/Feeds/FeedItemCard.vue";
import LoadingProgress from "../../components/General/LoadingProgress.vue";
import UserListItem from "../../components/Users/UserListItem.vue";
import TagListItem from "../../components/Tags/TagListItem.vue";
import { mapActions } from "vuex";

export default {
  data: function () {
    {
      return {
        tab: 0,

        tabItems: [
          { title: this.$t("tabs.posts"), data: "searchPostsData" },
          { title: this.$t("tabs.users"), data: "searchUsersData" },
          { title: this.$t("tabs.tags"), data: "searchTagsData" },
        ],

        data: {
          searchPostsData: [],
          searchUsersData: [],
          searchTagsData: [],
        },

        loadingList: {
          searchPostsData: false,
          searchUsersData: false,
          searchTagsData: false,
        },

        searchTextModel: "",
        oldSearchTextPost: "",
        oldSearchTextUser: "",
        oldSearchTextTag: "",

        allTags: [],
        tagResult: true,

        page: {
          post: 1,
          user: 1,
          tag: 1,
        },

        perPage: 15,

        moreButtonHidden: false,
      };
    }
  },
  components: {
    FeedItemCard,
    LoadingProgress,
    UserListItem,
    TagListItem,
  },
  methods: {
    searchText() {
      switch (this.tab) {
        case 0:
          this.page.post = 1;
          this.moreButtonHidden = false;
          this.data.searchPostsData = [];
          this.oldSearchTextPost = this.searchTextModel;
          this.getPosts();
          break;
        case 1:
          this.data.searchUsersData = [];
          this.oldSearchTextUser = this.searchTextModel;
          this.getUsers();
          break;
        case 2:
          this.data.searchTagsData = [];
          this.oldSearchTextTag = this.searchTextModel;
          this.getTags();
          break;
      }
    },

    getPosts() {
      let key = "kurumsal_haberler";
      let groupIds = "";
      let page = this.page.post;
      this.setLoading("post", true);

      UserService.getPosts(
        key,
        page,
        this.perPage,
        this.searchTextModel,
        groupIds
      )
        .then((res) => {
          if (page !== 1) {
            this.data.searchPostsData = [
              ...this.data.searchPostsData,
              ...res.data,
            ];
          } else {
            this.data.searchPostsData = res.data;
          }
          if (res.data.length <= 0) {
            this.moreButtonHidden = true;
          }
        })
        .catch(async (err) => {
          console.log("err : ", err);
          window.showError(err);
        })
        .then(() => {
          this.setLoading("post", false);
        });
    },

    getUsers() {
      this.setLoading("user", true);
      UserService.getUsers(this.searchTextModel)
        .then((res) => {
          this.data.searchUsersData = res.data.Data;
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.setLoading("user", false);
        });
    },

    getTags() {
      if (this.$store.state.tagList.length > 0) {
        this.allTags = this.$store.state.tagList;
        this.filterTag();
      } else {
        this.setLoading("tag", true);
        this.getTagList()
          .then(() => {
            this.allTags = this.$store.state.tagList;
            this.filterTag();
          })
          .catch((err) => {
            console.log("err :", err);
            showError(err);
          })
          .then(() => {
            this.setLoading("tag", false);
          });
      }
    },

    filterTag() {
      this.data.searchTagsData = this.allTags.filter((i) =>
        i.TagName.toUpperCase().includes(this.searchTextModel.toUpperCase())
      );
    },

    getLabel() {
      switch (this.tab) {
        case 0:
          return this.$t("labels.searchPost");
        case 1:
          return this.$t("labels.searchUser");
        case 2:
          return this.$t("labels.searchTag");
      }
    },

    setLoading(type, status) {
      switch (type) {
        case "post":
          this.loadingList.searchPostsData = status;
          break;
        case "user":
          this.loadingList.searchUsersData = status;
          break;
        case "tag":
          this.loadingList.searchTagsData = status;
          break;
      }
    },

    gotoPostWithTag(item) {
      this.searchTextModel = item.TagName;
      this.tab = 0;
      this.searchText();
    },

    loadMore() {
      this.page.post++;
      this.getPosts();
    },

    changeTab() {
      setTimeout(() => {
        if (this.searchTextModel.length) {
          switch (this.tab) {
            case 0:
              if (this.oldSearchTextPost != this.searchTextModel) {
                this.searchText();
              }
              break;
            case 1:
              if (this.oldSearchTextUser != this.searchTextModel) {
                this.searchText();
              }
              break;
            case 2:
              if (this.oldSearchTextTag != this.searchTextModel) {
                this.searchText();
              }
              break;
          }
        }
      }, 500);
    },

    ...mapActions(["getTagList"]),
  },
  computed: {},
  destroyed() {},
  mounted() {},
  watch: {},
};
</script>
